import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreModule } from '@dm/core';
import { FilePathDetailComponent } from './file-path-detail.component';

@NgModule({
    declarations: [FilePathDetailComponent],
    exports: [FilePathDetailComponent],
    imports: [
        CommonModule,
        CoreModule,
    ],
})
export class FilePathDetailModule { }
